export const isHomeLoadedGetter = "is Home Loaded getter";

export const courseInfoGetter = "course Info getter";

export const reservationGetter = "reservation getter";

export const courseListGetter = "course List getter";
